import {
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  Modal,
  Row,
  Col,
  Select,
  DatePicker,
} from "antd";
import { Trans, useTranslation } from "react-i18next";
import { useMemo } from "react";
import { UserOutlined } from "@ant-design/icons";
import useCreateAccount from "./useCreateAccount";

import { PASSWORD_MIN_LENGTH } from "../../constants/app";
import { Gender } from "../PatientDashboard/onboardingModal.qql";
import { CodeFiscaleInput, PhoneNumberInput, RegionInput } from "../Form";

const { Paragraph } = Typography;

const { Title } = Typography;

const CreateAccountForm = ({ type = "create" }: { type?: "create" | "book" }) => {
  const { t } = useTranslation();
  const {
    passwordVisible,
    setPasswordVisible,
  } = useCreateAccount();

  const isDefault = type === "create";

  const privacy = () => {
    Modal.info({
      title:
        "Condizioni generali In Buona Salute S.r.l./Pazienti In Buona Salute S.r.l.",
      centered: true,
      content: (
        <div>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list1_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list1_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list2_1" />
          </Paragraph>
          <ul style={{ paddingLeft: 16, fontSize: "smaller" }}>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list2_1_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list2_1_2" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list2_1_3" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list2_1_4" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list2_1_5" />
            </li>
          </ul>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_6" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_7" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list3_8" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list4_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list4_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list4_3" />
          </Paragraph>
          <ol style={{ paddingLeft: 16, fontSize: "smaller" }}>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list4_3_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list4_3_2" />
            </li>
          </ol>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list5_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_6" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_7" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list6_8" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list7" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list7_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list7_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list7_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8_1" />
          </Paragraph>
          <ul
            style={{
              paddingLeft: 16,
              fontSize: "smaller",
              listStyleType: "lower-alpha",
            }}
          >
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list8_1_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalCondizioni.list8_1_2" />
            </li>
          </ul>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list8_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list9" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list9_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list9_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list9_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list10_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list11" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list11_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list11_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list11_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_4" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_5" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list12_6" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list13" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list13_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list14" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list14_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list15" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list15_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontWeight: "bold",
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list16" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list16_1" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "10px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.list16_2" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              marginBottom: "2px",
              textAlign: "justify",
              lineBreak: "auto",
            }}
          >
            <Trans i18nKey="signupPage.modalCondizioni.last" />
          </Paragraph>
        </div>
      ),
      onOk() {},
    });
  };

  const consent = () => {
    Modal.info({
      title:
        "Informativa Privacy ai sensi dell’art. 13 del Regolamento UE 2016/ 679\n",
      centered: true,
      content: (
        <div style={{ paddingTop: 16 }}>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p1" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title2" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p2" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title3" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p3" />
          </Paragraph>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.subP3" />
          </Paragraph>
          <ul style={{ paddingLeft: 16, fontSize: "smaller" }}>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list1_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list1_2" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list1_3" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list1_4" />
            </li>
          </ul>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title4" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p4" />
          </Paragraph>
          <ul
            style={{
              paddingLeft: 16,
              listStyleType: "lower-alpha",
              fontSize: "smaller",
            }}
          >
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list2_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list2_2" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list2_3" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list2_4" />
            </li>
          </ul>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title5" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p5" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title6" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p6" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title7" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p7" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title8" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p8" />
          </Paragraph>
          <ul
            style={{
              paddingLeft: 16,
              listStyleType: "lower-position",
              fontSize: "smaller",
            }}
          >
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list3_1" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list3_2" />
            </li>
            <li>
              <Trans i18nKey="signupPage.modalPrivacy.list3_3" />
            </li>
          </ul>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title9" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p9" />
          </Paragraph>
          <Title level={5}>
            <Trans i18nKey="signupPage.modalPrivacy.title10" />
          </Title>
          <Paragraph
            style={{
              fontSize: "smaller",
              textAlign: "justify",
            }}
          >
            <Trans i18nKey="signupPage.modalPrivacy.p10" />
          </Paragraph>
        </div>
      ),
      onOk() {},
    });
  };

  const data = useMemo(() => {
    return [
      {
        label: t("form.label.name"),
        name: "name",
        rules: [{ required: true, message: t("form.error.name") }],
        layout: 12,
      },
      {
        label: t("form.label.surname"),
        name: "surname",
        rules: [{ required: true, message: t("form.error.surname") }],
        layout: 12,
      },
      {
        label: t("form.label.email"),
        name: "email",
        rules: [
          {
            required: true,
            type: "email" as const,
            message: t("form.error.email"),
          },
        ],
        layout: 12,
      },
      {
        label: t("form.label.password"),
        name: "password",
        rules: [
          {
            required: true,
            message: t("form.error.password"),
          },
          {
            min: PASSWORD_MIN_LENGTH,
            message: t("form.error.passwordMin", {
              length: PASSWORD_MIN_LENGTH,
            }),
          },
        ],
        layout: 12,
      },
      {
        label: "Data di nascita",
        name: "birthDate",
        rules: [{ required: true, message: t("form.error.birthDate") }],
        layout: 12,
      },
      {
        label: "Luogo di nascita",
        name: "birthPlace",
        rules: [{ required: true, message: t("form.error.birthPlace") }],
        layout: 12,
      },
      {
        label: t("form.label.phone"),
        name: "phone",
        rules: [{ required: true, message: t("form.error.phone") }],
        layout: isDefault ? 16 : 12,
      },
      {
        label: t("form.label.gender"),
        name: "gender",
        rules: [{ required: true, message: t("form.error.gender") }],
        layout: isDefault ? 8 : 12,
        options: [
          { value: "", label: null },
          { value: Gender.MALE, label: t("form.gender.male") },
          { value: Gender.FEMALE, label: t("form.gender.female") },
          {
            value: Gender.PREFER_TO_NOT_ANSWER,
            label: t("form.gender.notAnswered"),
          },
        ],
      },
      {
        label: t("form.label.address"),
        name: "address",
        rules: [{ required: true, message: t("form.error.address") }],
        layout: isDefault ? 16 : 12,
      },
      {
        label: t("form.label.cap"),
        name: "cap",
        rules: [{ required: true, message: t("form.error.cap") }],
        layout: isDefault ? 8 : 12,
      },
      {
        label: t("form.label.city"),
        name: "city",
        rules: [{ required: true, message: t("form.error.city") }],
        layout: 12,
      },
      {
        label: t("form.label.province"),
        name: "province",
        rules: [{ required: true, message: t("form.error.province") }],
        layout: 12,
      },
      {
        label: t("form.label.codeFisc"),
        name: "codFisc",
        rules: [{ required: true, message: t("form.error.codFisc") }],
        layout: isDefault ? 24 : 12,
      },
    ];
  }, []);

  return (
    <>
      <Row gutter={16}>
        {data.map((item) => (
          <Col span={24} sm={item.layout} key={item.name}>
            {(() => {
                switch (item.name) {
                  case "province":
                    return (
                      <RegionInput
                        name={item.name}
                        label={item.label}
                        rules={item.rules}
                      />
                    );
                  case "email":
                    return (
                      <Form.Item
                        label={item.label}
                        name={item.name}
                        rules={[
                          {
                            required: true,
                            type: "email",
                            message: t("form.error.email"),
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <UserOutlined
                              style={{ color: "rgba(0,0,0,.45)" }}
                            />
                          }
                          placeholder="Mail"
                        />
                      </Form.Item>
                    );
                  case "password":
                    return (
                      <Form.Item
                        label={item.label}
                        name={item.name}
                        rules={[
                          {
                            required: true,
                            message: t("form.error.password"),
                          },
                          {
                            min: PASSWORD_MIN_LENGTH,
                            message: t("form.error.passwordMin", {
                              length: PASSWORD_MIN_LENGTH,
                            }),
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Password"
                          visibilityToggle={{
                            visible: passwordVisible,
                            onVisibleChange: setPasswordVisible,
                          }}
                        />
                      </Form.Item>
                    );
                  case "phone":
                    return (
                      <PhoneNumberInput name={item.name} label={item.label} />
                    );
                  case "birthDate":
                    return (
                      <Form.Item
                        label={item.label}
                        name={item.name}
                        rules={item.rules}
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    );
                  case "codFisc":
                    return (
                      <CodeFiscaleInput name={item.name} label={item.label} />
                    );
                  case "gender":
                    return (
                      <Form.Item label={item.label} name={item.name} rules={item.rules}>
                        <Select options={item.options} />
                      </Form.Item>
                    );
                  default:
                    return (
                      <Form.Item
                        label={item.label}
                        name={item.name}
                        rules={item.rules}
                      >
                        <Input />
                      </Form.Item>
                    );
                }
              })()}
          </Col>
          ))}
      </Row>

      <Form.Item
        name="remember"
        rules={[{ required: true, message: t("form.error.remember") }]}
        valuePropName="checked"
        getValueFromEvent={(e) => (e.target.checked ? true : undefined)}
      >
        <Checkbox>
          <Trans
            i18nKey="signupPage.privacyPolicyLink"
            components={{
                linkWrap: (
                  <Button
                    type="link"
                    style={{ padding: 0, height: "auto" }}
                    onClick={privacy}
                  />
                ),
              }}
          />
        </Checkbox>
      </Form.Item>

      <Form.Item
        name="confirm"
        rules={[{ required: true, message: t("form.error.confirm") }]}
        valuePropName="checked"
        getValueFromEvent={(e) => (e.target.checked ? true : undefined)}
      >
        <Checkbox>
          <Trans
            i18nKey="signupPage.confirmLink"
            components={{
                linkWrap: (
                  <Button
                    type="link"
                    style={{ padding: 0, height: "auto" }}
                    onClick={consent}
                  />
                ),
              }}
          />
        </Checkbox>
      </Form.Item>

    </>
  );
};

export default CreateAccountForm;
